import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { OrganizationCompanySaveActions } from '@/features/organization-settings/components/organization-company-save-actions'
import { ContentSection } from '@/features/settings/components/content-section'
import { SupplierOrganizationIdentitySectionCard } from '@/features/suppliers/components/supplier-organization-identity-section-card'
import { useSupplierOrganizationForm } from '@/features/suppliers/context/supplier-organization-form-context'

export function SupplierOrganizationHomePage() {
  const { t } = useTranslation(['installations', 'common'])
  const {
    state,
    doesRequireLocalAddress,
    nameError,
    isSaving,
    isSaveDisabled,
    saveDisabledHint,
    onIdentityChange,
    onSaveChanges,
  } = useSupplierOrganizationForm()

  return (
    <ContentSection
      title={t('installations:suppliers.edit.pages.home.title')}
      desc={t('installations:suppliers.edit.pages.home.description')}
    >
      <div className="space-y-6">
        <Alert>
          <Info className="size-4" />
          <AlertDescription>{t('installations:suppliers.edit.alert')}</AlertDescription>
        </Alert>

        <SupplierOrganizationIdentitySectionCard
          name={state.name}
          localName={state.localName}
          businessRegistrationNumber={state.businessRegistrationNumber}
          country={state.country}
          doesRequireLocalName={doesRequireLocalAddress}
          nameError={nameError}
          variant="plain"
          onChange={onIdentityChange}
        />

        <OrganizationCompanySaveActions
          saveLabel={t('common:actions.save', { ns: 'common' })}
          isSaving={isSaving}
          isSaveDisabled={isSaveDisabled}
          saveDisabledHint={saveDisabledHint}
          onSave={onSaveChanges}
        />
      </div>
    </ContentSection>
  )
}
